import React, { useEffect, useState } from "react";
import {
  GetProducts,
  addProducts,
  editProducts,
  addPrices,
  editPrices,
  getGroups,
  getProductById,
  addColors,
  uploadImages,
  addImage,
  removeImage,
  getImages,
} from "../../apis/MyDukanProductsApi";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Unstable_Grid2";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminateModal from "../../utils/Loading";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { setLoadingPanel } from "../../redux/features/loading";
import Autocomplete from "@mui/material/Autocomplete";
import Pagination from "@mui/material/Pagination";
import { GetCategory } from "../../apis/MyDukanBrandApi";
import { GetBrands } from "../../apis/MyDukanBrandApi";
import CustomDropdown from "../../components/CustomDropdown";

export default function MyDukanProducts() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    primaryName: "",
    secondaryName: "",
    description: "",
    position: 0,
    productHsn: "",
    categoryId: "",
    subcategoryId: "",
    brandId: "",
    seriesId: "",
    productColors: [],
    isVerified: true,
    isActive: true,
  });
  const [colorRows, setColorRows] = useState([
    { colorId: null, colorHex: "", colorCode: "", colorName: "" },
  ]);
  const [priceData, setPriceData] = useState({});
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchBrand, setSearchBrand] = useState(null);
  const [searchBrandInput, setSearchBrandInput] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [seriesOptions, setSeriesOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [userGroupIds, setUserGroupIds] = useState([]);

  const now = new Date();
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0, 0, 0, 0);
  const pad = (num) => String(num).padStart(2, "0");
  const formattedDate = `${lastDay.getFullYear()}-${pad(
    lastDay.getMonth() + 1
  )}-${pad(lastDay.getDate())} ${pad(lastDay.getHours())}:${pad(
    lastDay.getMinutes()
  )}:${pad(lastDay.getSeconds())}`;

  const monthend = `${lastDay.getFullYear()}-${pad(
    lastDay.getMonth() + 1
  )}-${pad(lastDay.getDate())}`;

  const monthstart = `${lastDay.getFullYear()}-${pad(
    lastDay.getMonth() + 1
  )}-01`;

  const [imageFormData, setImageFormData] = useState({
    imageUrl: "",
    displayOrder: "0",
    type: "image",
    userGroupId: "144",
    periodFrom: monthstart,
    periodTo: monthend,
  });

  const handleImageFormChange = (e) => {
    const { name, value } = e.target;
    setImageFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClickOpen = () => {
    setOpen(true);
    setFormData({
      id: "",
      primaryName: "",
      secondaryName: "",
      description: "",
      position: 0,
      productHsn: "",
      categoryId: "",
      subcategoryId: "",
      brandId: "",
      seriesId: "",
      productColors: [],
      isVerified: true,
      isActive: true,
    });
    setColorRows([
      { colorId: null, colorHex: "", colorCode: "", colorName: "" },
    ]);
    setPriceData({});
    setIsEdit(false);
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      id: "",
      primaryName: "",
      secondaryName: "",
      description: "",
      position: 0,
      productHsn: "",
      categoryId: "",
      subcategoryId: "",
      brandId: "",
      seriesId: "",
      productColors: [],
      isVerified: true,
      isActive: true,
    });
    setColorRows([
      { colorId: null, colorHex: "", colorCode: "", colorName: "" },
    ]);
    setPriceData({});
    setIsEdit(false);
  };

  useEffect(() => {
    dispatch(setLoadingPanel(true));
    GetProducts({ maxResult: 999 }).then((res) => {
      setProducts(res.data?.products || []);
    });
    dispatch(setLoadingPanel(false));
  }, []);

  const fetchCategoriesAndBrands = async () => {
    try {
      dispatch(setLoadingPanel(true));
      const catRes = await GetCategory({});
      setCategories(catRes.data?.categories || []);
      const brandRes = await GetBrands({ page: 0, size: 999 });
      const brandsArray = (brandRes.data?.brands || []).filter((b) => b.active);
      setBrands(brandsArray);
    } catch (err) {
      toast("Error fetching categories/brands", { type: "error" });
    } finally {
      dispatch(setLoadingPanel(false));
    }
  };

  useEffect(() => {
    fetchCategoriesAndBrands();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleColorChange = (idx, e) => {
    const { name, value } = e.target;
    setColorRows((prev) =>
      prev.map((row, i) => (i === idx ? { ...row, [name]: value } : row))
    );
  };

  const handleAddColorRow = () => {
    const newColor = {
      colorId: null,
      colorHex: "",
      colorCode: "",
      colorName: "",
      isNew: true,
    };
    setColorRows((prev) => [...prev, newColor]);
  };

  const handleRemoveColorRow = (idx) => {
    setColorRows((prev) => prev.filter((_, i) => i !== idx));
  };

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    setPriceData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    let productPayload;
    if (isEdit) {
      productPayload = {
        id: formData.id || null,
        primaryName: formData.primaryName,
        secondaryName: formData.secondaryName,
        productHsn: formData.productHsn,
        position: formData.position,
      };
    } else {
      productPayload = {
        id: formData.id || null,
        primaryName: formData.primaryName,
        secondaryName: formData.secondaryName,
        productImg: formData.productImg || "",
        productVideo: formData.productVideo || "",
        description: formData.description,
        productHsn: formData.productHsn,
        position: formData.position,
        categoryId: formData.categoryId,
        subcategoryId: formData.subcategoryId,
        brandId: formData.brandId,
        seriesId: formData.seriesId,
        productColors: colorRows,
        skProductPrice: {
          productPriceId: priceData.productPriceId || null,
          primaryPrice: Number(priceData.primaryPrice) || 0,
          secondaryPrice: Number(priceData.secondaryPrice) || 0,
          discountValue: priceData.discountValue || 0,
          discountPercent: priceData.discountPercent || 0,
          priceDop: Number(priceData.priceDop) || 0,
          priceMop: Number(priceData.priceMop) || 0,
          priceMrp: Number(priceData.priceMrp) || 0,
          isValid: priceData.isValid || 1,
          validityPeriod: priceData.validityPeriod || 1000,
          isAdminPrice: priceData.isAdminPrice || 0,
          isUserPrice: priceData.isUserPrice || 0,
          isGroupPrice: priceData.isGroupPrice || 1,
          isStorePrice: priceData.isStorePrice || 0,
          validityDate: priceData.validityDate || formattedDate,
        },
        isVerified: formData.isVerified,
        isActive: formData.isActive,
      };
    }
    const pricePayload = {
      productPriceId: priceData.productPriceId || null,
      primaryPrice: Number(priceData.primaryPrice) || 0,
      secondaryPrice: Number(priceData.secondaryPrice) || 0,
      discountValue: priceData.discountValue || 0,
      discountPercent: priceData.discountPercent || 0,
      priceDop: Number(priceData.priceDop) || 0,
      priceMop: Number(priceData.priceMop) || 0,
      priceMrp: Number(priceData.priceMrp) || 0,
      isValid: priceData.isValid || 1,
      validityPeriod: priceData.validityPeriod || 1000,
      isAdminPrice: priceData.isAdminPrice || 0,
      isUserPrice: priceData.isUserPrice || 0,
      isGroupPrice: priceData.isGroupPrice || 1,
      isStorePrice: priceData.isStorePrice || 0,
      validityDate: priceData.validityDate || formattedDate,
      groupDto: {
        userGroupId: "144",
        groupName: "P All Users",
      },
    };
    try {
      if (isEdit) {
        const productRes = await editProducts(productPayload);
        const priceRes = await editPrices(
          pricePayload,
          productPayload.id || ""
        );
      } else {
        const productRes = await addProducts(productPayload);
        const priceRes = await addPrices(
          pricePayload,
          productRes.data.product?.id || ""
        );
      }
      const productId = productPayload.id;
      const newColors = colorRows
        .filter((row) => row.isNew)
        .map(({ isNew, ...color }) => color);
      if (isEdit && newColors.length > 0) {
        await addColors(newColors, productPayload.id);
      }
      toast(isEdit ? "Product Updated" : "Product Added", {
        type: "success",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
      setOpen(false);
      setFormData({
        id: "",
        primaryName: "",
        secondaryName: "",
        description: "",
        position: 0,
        productHsn: "",
        categoryId: "",
        subcategoryId: "",
        brandId: "",
        seriesId: "",
        productColors: [],
        isVerified: true,
        isActive: true,
      });
      setColorRows([
        { colorId: null, colorHex: "", colorCode: "", colorName: "" },
      ]);
      setPriceData({});
        setSearchTerm("");
      setSearchBrand(null);
      setSearchBrandInput("");
      GetProducts({ maxResult: 999 }).then((res) => {
        setProducts(res.data?.products || []);
      });
    } catch (err) {
      toast(err?.response?.data?.message || "Error saving product", {
        type: "error",
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
    }
  };

  const fetchProductForEdit = async (productId) => {
    try {
      const res = await getProductById(productId);
      const product = res.data?.product || {};
      setFormData({
        id: product.id || null,
        primaryName: product.primaryName || "",
        secondaryName: product.secondaryName || "",
        description: product.description || "",
        position: product.position || 0,
        productHsn: product.productHsn || "",
        categoryId: product.skCategory?.id || "",
        categoryName: product.skCategory?.name || "",
        subcategoryId: product.subcategory?.subcategoryId || "",
        subcategoryName: product.subcategory?.subcategoryName || "",
        brandId: product.productBrand?.brandId || "",
        brandName: product.productBrand?.brandName || "",
        seriesId: product.skBrandSeries?.seriesId || "",
        seriesName: product.skBrandSeries?.seriesName || "",
        productColors: product.productColors || [
          { colorId: null, colorHex: "", colorCode: "", colorName: "" },
        ],
        isVerified: product.verified ?? true,
        isActive: product.active ?? true,
      });
      setColorRows(
        product.productColors || [
          { colorId: null, colorHex: "", colorCode: "", colorName: "" },
        ]
      );
      setPriceData(product.skProductPrices?.[0] || {});
      setSubcategoryOptions(product.skCategory?.subcategories || []);
      setSeriesOptions(product.productBrand?.brandSeries || []);
      setIsEdit(true);
      setOpen(true);
    } catch (err) {
      toast("Error fetching product details", { type: "error" });
    }
  };

  const handleEdit = (product) => {
    fetchProductForEdit(product.productId || product.id);
  };

  const openImageModal = async (id, primaryName) => {
    try {
      const groupsRes = await getGroups();
      const groups = groupsRes.data?.groups || [];
      const ids = groups.map((group) => group.userGroupId);
      setUserGroupIds(groups);

      const now = new Date();
      const currentYearStart = `${now.getFullYear()}-01-01`;
      const nextYearStart = `${now.getFullYear() + 1}-01-01`;

      const imagesRes = await getImages({
        productId: id,
        userGroupId: ids.join(","),
        periodFrom: currentYearStart,
        periodTo: nextYearStart,
      });
      const files = imagesRes.data?.content?.[0]?.imageUrls || [];
      setUploadedFiles(files);

      setImageFormData((prev) => ({
        ...prev,
        productId: id,
        primaryName: primaryName,
      }));

      setImageModalOpen(true);
    } catch (err) {
      toast("Error fetching user groups or images", { type: "error" });
    }
  };

  const closeImageModal = () => {
    setImageModalOpen(false);
    setUploadedFiles([]);
    setSelectedFile(null);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUploadFile = async () => {
    if (!selectedFile) {
      toast("Please select a file to upload", { type: "warning" });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      const base64Content = event.target.result;
      const payload = [
        {
          content: base64Content,
          fileName: selectedFile.name,
        },
      ];

      try {
        const uploadRes = await uploadImages(payload);
        const fileUrl = uploadRes.data?.fileUrls?.[0]?.fileUrl;

        setImageFormData((prev) => ({
          ...prev,
          imageUrl: fileUrl,
        }));

        toast("File uploaded successfully", { type: "success" });
      } catch (err) {
        toast("Error uploading file", { type: "error" });
      }
    };

    reader.readAsDataURL(selectedFile);
  };

  const handleSaveImage = async () => {
    const now = new Date();
    const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    const currentMonthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    try {
      const addImagePayload = {
        productId: imageFormData.productId,
        imageUrl: imageFormData.imageUrl,
        primaryName: imageFormData.primaryName,
        type: imageFormData.type,
        displayOrder: imageFormData.displayOrder,
        userGroupId: imageFormData.userGroupId,
        periodFrom: currentMonthStart.toISOString().split("T")[0],
        periodTo: currentMonthEnd.toISOString().split("T")[0],
      };

      await addImage(addImagePayload);
      toast("Image added successfully", { type: "success" });

      setImageFormData({
        imageUrl: "",
        displayOrder: "0",
        type: "image",
        userGroupId: "144",
        periodFrom: currentMonthStart.toISOString().split("T")[0],
        periodTo: currentMonthEnd.toISOString().split("T")[0],
      });
      setSelectedFile(null);
      closeImageModal();
    } catch (err) {
      toast("Error adding image", { type: "error" });
    }
  };

  const handleRemoveFile = async (fileId) => {
    try {
      const payload = { productImageId: fileId };
      await removeImage(payload);
      setUploadedFiles((prev) =>
        prev.filter((file) => file.productImageId !== fileId)
      );
      toast("File removed successfully", { type: "success" });
    } catch (err) {
      toast("Error removing file", { type: "error" });
    }
  };

  return (
    <>
      <CircularIndeterminateModal open={isLoading} />
      <div
        className={"page-card mb-6"}
      >
        <div className="w-full lg:w-[70%] p-4 md:p-8 flex items-center gap-4">
          <TextField
            label="Search by Product Name"
            placeholder="Search by product name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            helperText="Type to search products..."
            variant="outlined"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />            
          <CustomDropdown
            options={brands}
            value={searchBrand?.id || ""}
            onChange={(selectedBrand) => {
              setSearchBrand(selectedBrand);
              if (selectedBrand && selectedBrand.id) {
                GetProducts({ brandId: selectedBrand.id, maxResult: 999 }).then(
                  (res) => {
                    setProducts(res.data?.products || []);
                  }
                );
              } else {
                GetProducts({ maxResult: 999 }).then((res) => {
                  setProducts(res.data?.products || []);
                });
              }
            }}
            getOptionLabel={(option) => option.name || ""}
            getOptionValue={(option) => option.id}
            label="Search by Brand"
            placeholder="Type to search brands..."
            helpText="Type to get the options"
            fullWidth={false}
            sx={{ minWidth: 220 }}
          />
        </div>
        <div className="w-full lg:w-[30%] md:p-8 p-4 flex items-center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickOpen}
            fullWidth
            sx={{
              height: { xs: "40px", md: "52px" },
              fontSize: {
                xs: "12px",
                sm: "13px",
                md: "13px",
                lg: "16px",
              },
            }}
          >
            Add Product
          </Button>
        </div>
      </div>
      <div
        className="page-card mb-6"
      >
        <div className="flex justify-center p-4">
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={(_, value) => setPage(value - 1)}
            color="primary"
            size="medium"
          />
        </div>
        <div className="block w-full overflow-x-auto py-3 px-4 lg:p-8">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <TableHeader heading="Primary Name" />
                <TableHeader heading="Brand Name" />
                <TableHeader heading="Series Name" />
                <TableHeader heading="Created On" />
                <TableHeader heading="Active" />
                <TableHeader heading="Verified" />
                <TableHeader heading="Position" />
                <TableHeader heading="Action" />
                <TableHeader heading="ADD IMAGE" />
              </tr>
            </thead>
            <tbody>
              {products
                .filter((p) =>
                  p.primaryName.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((product, i) => (
                  <tr
                    key={product.productId}
                    style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                  >
                    <TableElement value={product.primaryName} />
                    <TableElement value={product.brandName} />
                    <TableElement value={product.seriesName} />
                    <TableElement value={product.createdOn} />
                    <TableElement value={product.active ? "Yes" : "No"} />
                    <TableElement value={product.verified ? "Yes" : "No"} />
                    <TableElement value={product.position} />
                    <TableElement
                      value={
                        <span
                          className="cursor-pointer text-sky-500 hover:text-sky-950 font-bold"
                          onClick={() => {
                            handleEdit(product);
                          }}
                        >
                          EDIT
                        </span>
                      }
                    />
                    <TableElement
                      value={
                        <span
                          className="cursor-pointer text-sky-500 hover:text-sky-950 font-bold"
                          onClick={() =>
                            openImageModal(
                              product.productId,
                              product.primaryName
                            )
                          }
                        >
                          ADD IMAGE
                        </span>
                      }
                    />
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <Dialog fullScreen open={open} onClose={handleClose}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              {isEdit
                ? `Edit Product - ${formData.primaryName}`
                : "Add Product"}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
          <form>
            <div style={{ borderRadius: 8, padding: 0, marginBottom: 24 }}>
              <TextField
                required
                label="Primary Name"
                name="primaryName"
                value={formData.primaryName}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="Secondary Name"
                name="secondaryName"
                value={formData.secondaryName}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <div
                style={{
                  fontSize: "12px",
                  color: "#888",
                  marginBottom: "8px",
                  marginTop: "-12px",
                  letterSpacing: "0.2em",
                }}
              >
                ex. Brand Name &lt;space&gt; Primary Name &lt;space&gt;
                Secondary Name
              </div>
              <TextField
                type="number"
                label="Position"
                name="position"
                value={formData.position}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="Product HSN"
                name="productHsn"
                value={formData.productHsn}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
              />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <Autocomplete
                  options={categories}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    formData.categoryId && formData.categoryName
                      ? { id: formData.categoryId, name: formData.categoryName }
                      : null
                  }
                  onChange={(_, newValue) => {
                    setFormData({
                      ...formData,
                      categoryId: newValue ? newValue.id : "",
                      categoryName: newValue ? newValue.name : "",
                    });
                    setSubcategoryOptions(
                      newValue && newValue.subcategories
                        ? newValue.subcategories
                        : []
                    );
                    setFormData((prev) => ({
                      ...prev,
                      subcategoryId: "",
                      subcategoryName: "",
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Category"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <Autocomplete
                  options={subcategoryOptions}
                  getOptionLabel={(option) => option.subcategoryName || ""}
                  value={
                    formData.subcategoryId && formData.subcategoryName
                      ? {
                          subcategoryId: formData.subcategoryId,
                          subcategoryName: formData.subcategoryName,
                        }
                      : null
                  }
                  onChange={(_, newValue) => {
                    setFormData({
                      ...formData,
                      subcategoryId: newValue ? newValue.subcategoryId : "",
                      subcategoryName: newValue ? newValue.subcategoryName : "",
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subcategory"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option && value
                      ? option.subcategoryId === value.subcategoryId
                      : false
                  }
                />
              </FormControl>              
              <FormControl fullWidth sx={{ mb: 2 }}>
                <CustomDropdown
                  options={brands}
                  value={formData.brandId}
                  onChange={(selectedBrand) => {
                    setFormData({
                      ...formData,
                      brandId: selectedBrand ? selectedBrand.id : "",
                      brandName: selectedBrand ? selectedBrand.name : "",
                    });
                    setSeriesOptions(
                      selectedBrand && selectedBrand.series ? selectedBrand.series : []
                    );
                    setFormData((prev) => ({
                      ...prev,
                      seriesId: "",
                      seriesName: "",
                    }));
                  }}
                  getOptionLabel={(option) => option.name || ""}
                  getOptionValue={(option) => option.id}
                  label="Brand"
                  helpText="Search brands by typing"
                  placeholder="Type to search brands..."
                  fullWidth
                  sx={{ mb: 0 }}
                />
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <Autocomplete
                  options={seriesOptions}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    formData.seriesId && formData.seriesName
                      ? {
                          seriesId: formData.seriesId,
                          name: formData.seriesName,
                        }
                      : null
                  }
                  onChange={(_, newValue) => {
                    setFormData({
                      ...formData,
                      seriesId: newValue ? newValue.seriesId : "",
                      seriesName: newValue ? newValue.name : "",
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Series"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.seriesId === value.seriesId : false
                  }
                />
              </FormControl>
              <div style={{ marginTop: 24 }}>
                <div
                  style={{ fontWeight: 600, fontSize: 18, marginBottom: 12 }}
                >
                  Colors
                </div>
                {colorRows.map((row, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 16,
                      marginBottom: 20,
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <TextField
                      label="Color Hex"
                      name="colorHex"
                      value={row.colorHex}
                      onChange={(e) => handleColorChange(idx, e)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      sx={{ flex: 1, minWidth: 180 }}
                    />
                    <TextField
                      label="Color Code"
                      name="colorCode"
                      value={row.colorCode}
                      onChange={(e) => handleColorChange(idx, e)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      sx={{ flex: 1, minWidth: 180 }}
                    />
                    <TextField
                      label="Color Name"
                      name="colorName"
                      value={row.colorName}
                      onChange={(e) => handleColorChange(idx, e)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      sx={{ flex: 2, minWidth: 220 }}
                    />
                    <Button
                      variant="contained"
                      onClick={handleAddColorRow}
                      sx={{ minWidth: 40, px: 0, height: 40 }}
                    >
                      +
                    </Button>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 24 }}>
                <div
                  style={{ fontWeight: 600, fontSize: 18, marginBottom: 12 }}
                >
                  Price
                </div>
                {/* <TextField
                  type="number"
                  label="Primary Price"
                  name="primaryPrice"
                  value={priceData.primaryPrice || ""}
                  onChange={handlePriceChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  type="number"
                  label="Secondary Price"
                  name="secondaryPrice"
                  value={priceData.secondaryPrice || ""}
                  onChange={handlePriceChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  InputLabelProps={{ shrink: true }}
                /> */}
                <TextField
                  type="number"
                  label="Price DOP*"
                  name="priceDop"
                  value={priceData.priceDop || ""}
                  onChange={handlePriceChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  type="number"
                  label="Price MOP*"
                  name="priceMop"
                  value={priceData.priceMop || ""}
                  onChange={handlePriceChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  type="number"
                  label="Price MRP*"
                  name="priceMrp"
                  value={priceData.priceMrp || ""}
                  onChange={handlePriceChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave}>
            {isEdit ? "Save Changes" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={imageModalOpen} onClose={closeImageModal}>
        <DialogTitle>Manage Files</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            {uploadedFiles.map((file, index) => (
              <div key={index} style={{ width: "200px", textAlign: "center", marginBottom: "16px" }}>
                {file.type === "doc" || file.type === "Doc" ? (
                  <iframe
                    src={file.imageUrl}
                    style={{
                      width: "100%",
                      height: "300px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                    title={`Document ${index + 1}`}
                  ></iframe>
                ) : (
                  <img
                    src={file.imageUrl}
                    alt={`Uploaded ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                )}
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleRemoveFile(file.productImageId)}
                  style={{ marginTop: "8px" }}
                >
                  Remove
                </Button>
              </div>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            <input
              type="file"
              onChange={handleFileChange}
              style={{ flex: 1 }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleUploadFile}
              style={{ flex: 1 }}
            >
              Upload File
            </Button>
          </div>

          <TextField
            label="URL"
            name="imageUrl"
            value={imageFormData.imageUrl}
            onChange={handleImageFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Display Order"
            name="displayOrder"
            value={imageFormData.displayOrder}
            onChange={handleImageFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Type</InputLabel>
            <Select
              name="type"
              value={imageFormData.type}
              onChange={handleImageFormChange}
            >
              <MenuItem value="image">Image</MenuItem>
              <MenuItem value="doc">Document</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>User Group Map ID</InputLabel>
            <Select
              name="userGroupId"
              value={imageFormData.userGroupId}
              onChange={handleImageFormChange}
            >
              {userGroupIds.map((group, index) => (
                <MenuItem key={index} value={group.userGroupId}>
                  {group.groupName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="From"
            name="periodFrom"
            value={imageFormData.periodFrom}
            onChange={handleImageFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="To"
            name="periodTo"
            value={imageFormData.periodTo}
            onChange={handleImageFormChange}
            fullWidth
            sx={{ mb: 2 }}
          />

          <div style={{ textAlign: "center", marginTop: "24px" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveImage}
              style={{ width: "200px" }}
            >
              Save
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeImageModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
